import { render, staticRenderFns } from "./ReCaptcha.vue?vue&type=template&id=4424f830&"
import script from "./ReCaptcha.vue?vue&type=script&lang=js&"
export * from "./ReCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielkaschlaw/Desktop/Sites/devTools_shit/61381/9/meliorisVueTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4424f830')) {
      api.createRecord('4424f830', component.options)
    } else {
      api.reload('4424f830', component.options)
    }
    module.hot.accept("./ReCaptcha.vue?vue&type=template&id=4424f830&", function () {
      api.rerender('4424f830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/ReCaptcha.vue"
export default component.exports